import { r as registerInstance, c as createEvent, h, H as Host, g as getElement } from './index-1d3c5472.js';

const patternlibTabsCss = "*,::before,::after{box-sizing:border-box;border-width:0;border-style:solid;border-color:var(--color-steel-200)}::before,::after{--tw-content:''}html{line-height:1.5;-webkit-text-size-adjust:100%;-moz-tab-size:4;-o-tab-size:4;tab-size:4;font-family:ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\"}body{margin:0;line-height:inherit}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-family:ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-0.25em}sup{top:-0.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}button,input,optgroup,select,textarea{font-family:inherit;font-size:100%;font-weight:inherit;line-height:inherit;color:inherit;margin:0;padding:0}button,select{text-transform:none}button,[type='button'],[type='reset'],[type='submit']{-webkit-appearance:button;background-color:transparent;background-image:none}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}progress{vertical-align:baseline}::-webkit-inner-spin-button,::-webkit-outer-spin-button{height:auto}[type='search']{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}blockquote,dl,dd,h1,h2,h3,h4,h5,h6,hr,figure,p,pre{margin:0}fieldset{margin:0;padding:0}legend{padding:0}ol,ul,menu{list-style:none;margin:0;padding:0}textarea{resize:vertical}input::-moz-placeholder,textarea::-moz-placeholder{opacity:1;color:var(--color-steel-400)}input::placeholder,textarea::placeholder{opacity:1;color:var(--color-steel-400)}button,[role=\"button\"]{cursor:pointer}:disabled{cursor:default}img,svg,video,canvas,audio,iframe,embed,object{display:block;vertical-align:middle}img,video{max-width:100%;height:auto}[hidden]{display:none}*,::before,::after{--tw-border-spacing-x:0;--tw-border-spacing-y:0;--tw-translate-x:0;--tw-translate-y:0;--tw-rotate:0;--tw-skew-x:0;--tw-skew-y:0;--tw-scale-x:1;--tw-scale-y:1;--tw-scroll-snap-strictness:proximity;--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-color:rgb(59 130 246 / 0.5);--tw-ring-offset-shadow:0 0 #0000;--tw-ring-shadow:0 0 #0000;--tw-shadow:0 0 #0000;--tw-shadow-colored:0 0 #0000;}::backdrop{--tw-border-spacing-x:0;--tw-border-spacing-y:0;--tw-translate-x:0;--tw-translate-y:0;--tw-rotate:0;--tw-skew-x:0;--tw-skew-y:0;--tw-scale-x:1;--tw-scale-y:1;--tw-scroll-snap-strictness:proximity;--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-color:rgb(59 130 246 / 0.5);--tw-ring-offset-shadow:0 0 #0000;--tw-ring-shadow:0 0 #0000;--tw-shadow:0 0 #0000;--tw-shadow-colored:0 0 #0000;}.h-auto{height:auto}.resize{resize:both}.gap-y-\\[12px\\]{row-gap:12px}.overflow-auto{overflow:auto}.overflow-y-hidden{overflow-y:hidden}.uppercase{text-transform:uppercase}.filter{filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}:host{display:block;--inner-shadow-color:rgba(0, 0, 0, 0.2)}.tab-container{display:flex;-webkit-user-select:none;-moz-user-select:none;user-select:none;padding:var(--spacing-0);padding-top:var(--padding-top);scroll-behavior:smooth;transition:box-shadow 0.3s}.tab-container::-webkit-scrollbar{height:8px}.tab-container::-webkit-scrollbar-track{background:inherit}.tab-container::-webkit-scrollbar-thumb{background:rgba(0, 0, 0, 0)}.tab-container:hover::-webkit-scrollbar-thumb{background:var(--color-steel-700) !important}.tab-container.innerShadowRight{box-shadow:inset -12px 0 9px -12px var(--inner-shadow-color), inset 0 0 0 0 var(--inner-shadow-color)}.tab-container.innerShadowLeft{box-shadow:inset 0 0 0 0 var(--inner-shadow-color), inset 9px 0 9px -7px var(--inner-shadow-color)}.tab-container.innerShadow{box-shadow:inset -12px 0 12px -12px var(--inner-shadow-color), inset 9px 0 9px -7px var(--inner-shadow-color)}.tab-container.small{height:42px}.tab-container.big{height:52px}@media (min-width: 768px){.tablet\\:flex-wrap{flex-wrap:wrap}}@media (min-width: 1280px){.desktop\\:gap-y-\\[4px\\]{row-gap:4px}}";

const PatternlibTabs = class {
  handleResize() {
    this.checkScrollOverflow();
  }
  /**
   * Public function to set the active tab
   */
  async setTabToActive(itemId) {
    await this.openTab(itemId);
    this.checkScrollOverflow();
  }
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.change = createEvent(this, "lhChangeItem", 7);
    this.alignItems = 'center';
    this.size = 'big';
    this.customHeight = undefined;
    this.paddingTop = '0px';
    this.subtle = undefined;
    this.noOverflow = false;
    this.noOverflowShadow = false;
    this.trackScroll = this.trackScroll.bind(this);
  }
  componentWillLoad() {
    this.scrollPos = 0;
    this.hostElement.style.setProperty('--padding-top', '0px');
  }
  componentDidLoad() {
    this.checkScrollOverflow();
  }
  componentDidUpdate() {
    this.checkScrollOverflow();
  }
  async openTab(itemId) {
    var _a;
    const tabItems = this.queryTabItems();
    (_a = tabItems.filter(x => x.itemId == itemId)) === null || _a === void 0 ? void 0 : _a.map(x => x.setActiveState(true));
    this.unselectAllOther(itemId);
  }
  async trackScroll() {
    const el = this.tabContainer;
    const tabContainerWidth = el.clientWidth;
    const scrollWidth = el.scrollWidth;
    const scrollLeft = el.scrollLeft;
    const offset = 16;
    const scrollLength = scrollWidth - tabContainerWidth;
    this.scrollPos = scrollLeft;
    if (!this.noOverflowShadow) {
      el.classList.add('innerShadow');
      if (scrollLeft > scrollLength - offset) {
        el.classList.remove('innerShadow', 'innerShadowRight');
        el.classList.add('innerShadowLeft');
      }
      else if (scrollLeft < offset) {
        el.classList.remove('innerShadow', 'innerShadowLeft');
        el.classList.add('innerShadowRight');
      }
      else {
        el.classList.remove('innerShadowRight', 'innerShadowLeft');
      }
    }
  }
  checkScrollOverflow() {
    if (this.tabContainer != null) {
      const offset = 2;
      const tabContainerWidth = this.tabContainer.clientWidth;
      const scrollWidth = this.tabContainer.scrollWidth - offset;
      if (scrollWidth > tabContainerWidth) {
        !this.noOverflowShadow && this.tabContainer.classList.add('innerShadowRight');
        this.hostElement.style.setProperty('--padding-top', this.paddingTop);
      }
      else {
        !this.noOverflowShadow && this.tabContainer.classList.remove('innerShadowRight', 'innerShadowLeft');
        this.hostElement.style.setProperty('--padding-top', '0px');
      }
      const tabItems = this.queryTabItems();
      if (tabItems != null && tabItems.length > 0) {
        tabItems
          .filter(item => item.itemId === this.activeItemId)
          .map(tabItem => {
          if (tabItem != null) {
            const tabItemRect = tabItem.getBoundingClientRect();
            const tabContainerRect = this.tabContainer.getBoundingClientRect();
            const tabContainerX = tabContainerRect.x;
            const tabContainerRightX = tabContainerRect.x + tabContainerWidth;
            const tabItemX = tabItemRect.x;
            const tabItemRightX = tabItemRect.x + tabItemRect.width;
            const scrollPosX = this.scrollPos + (tabItemX - tabContainerX) - 48;
            const scrollPosRightX = this.scrollPos + (tabItemRightX - tabContainerRightX) + 48;
            if (tabItemX < tabContainerX) {
              this.tabContainer.scrollTo(scrollPosX, 0);
            }
            else if (tabItemRightX > tabContainerRightX) {
              this.tabContainer.scrollTo(scrollPosRightX, 0);
            }
          }
        });
      }
    }
  }
  onItemActivation(event) {
    const itemId = event.detail;
    this.activeItemId = itemId;
    this.unselectAllOther(itemId);
    this.checkScrollOverflow();
    this.change.emit({ itemId: itemId });
  }
  unselectAllOther(itemId) {
    // Set all other tabs to inactive
    const tabItems = this.queryTabItems();
    const allOthers = tabItems.filter(item => item.itemId != itemId);
    allOthers.map(item => item.setActiveState(false));
  }
  queryTabItems() {
    var _a;
    const slot = this.hostElement.shadowRoot.querySelector('slot');
    const nodes = (_a = slot === null || slot === void 0 ? void 0 : slot.assignedNodes().filter(node => node.nodeName === 'PATTERNLIB-TABS-ITEM')) !== null && _a !== void 0 ? _a : [];
    return nodes.map(node => node);
  }
  render() {
    const tabContainerClass = {
      'overflow-auto overflow-y-hidden': !this.noOverflow,
      'gap-y-[12px] desktop:gap-y-[4px] tablet:flex-wrap overflow-auto overflow-y-hidden': this.noOverflow,
      'tab-container': true,
      [this.size]: !this.noOverflow,
      'h-auto': this.noOverflow,
    };
    const tabContainerStyles = {
      alignItems: this.alignItems,
      height: this.customHeight,
    };
    return (h(Host, null, h("div", { class: tabContainerClass, style: tabContainerStyles, onScroll: this.trackScroll, ref: el => (this.tabContainer = el) }, h("slot", null))));
  }
  get hostElement() { return getElement(this); }
};
PatternlibTabs.style = patternlibTabsCss;

export { PatternlibTabs as patternlib_tabs };
